module.exports = __webpack_public_path__ + "static/media/Ok.503ec423.png";